import includes from 'ramda/src/includes';

export const isIncludePeakmade = includes("peakmade");
